/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';

import { Collapse } from '@atoms';
import { NO_MARGIN_BOTTOM } from '@constants';
import { pluralize } from '@utils';
import Form from '@organisms/Form';

import RuleForm from '../RuleForm';
import RulesList from '../RulesList';

const RulesField = ({ name, rules, ...props }) => {
  return (
    <Form.WithFieldValue name={name} style={NO_MARGIN_BOTTOM}>
      {(_rules, { setFieldsValue }) => (
        <>
          <Collapse style={{ marginBottom: 40 }}>
            <Collapse.Panel header="New rule">
              <RuleForm {...props} onSuccess={(rule) => setFieldsValue({ [name]: [..._rules, rule] })} />
            </Collapse.Panel>
          </Collapse>
          <Collapse>
            <Collapse.Panel header="Rules" note={pluralize(_rules?.length, 'rule')}>
              <RulesList {...props} value={_rules} onChange={(newRules) => setFieldsValue({ [name]: newRules })} />
            </Collapse.Panel>
          </Collapse>
        </>
      )}
    </Form.WithFieldValue>
  );
};

export default RulesField;
